import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "order_status--container",
  "data-cy": "order-status-container"
}
const _hoisted_2 = { class: "order-item-status" }
const _hoisted_3 = {
  key: 0,
  class: "bold order_status--options-header"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "additional-tags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")!
  const _component_q_menu = _resolveComponent("q-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.statusArray)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.statusArray, (s, i) => {
            return (_openBlock(), _createBlock(_component_Label, {
              class: _normalizeClass(["order_status--label", {'has-options': !!_ctx.parsedOptions, 'has-tooltip': typeof _ctx.metadata?.[s]?.label === 'string'}]),
              key: `status-${s}-${i}_${_ctx.id}`,
              value: `${_ctx.format.status(s, _ctx.labelVariant)}${_ctx.format.capitalize(_ctx.getMetadataTag(_ctx.metadata, s))}`,
              color: _ctx.format.status(s, 'color'),
              "data-color": _ctx.format.status(s, 'color'),
              style: _normalizeStyle(`height: 24px; border-top-color:${_ctx.format.status(s, 'color')}; width: auto !important`),
              "data-tooltip": _ctx.metadata?.[s]?.message,
              onClick: _ctx.toggle
            }, null, 8, ["value", "color", "data-color", "style", "class", "data-tooltip", "onClick"]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.parsedOptions)
        ? (_openBlock(), _createBlock(_component_q_menu, {
            key: 1,
            class: "order_status--options-container",
            offset: _ctx.offset,
            anchor: _ctx.anchor,
            "max-width": "320px",
            "transition-duration": "100"
          }, {
            default: _withCtx(() => [
              (_ctx.optionsHeader)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_3, _toDisplayString(_ctx.optionsHeader), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedOptions, (option, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["order_status--option", {active: _ctx.statusArray.includes(option.id)}]),
                  onClick: _withModifiers(($event: any) => (_ctx.select(option, $event)), ["stop"])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["option__label", {combinable: option.combinable}])
                  }, _toDisplayString(_ctx.format.status(option.id, _ctx.labelVariant)), 3),
                  (_ctx.statusArray.length > 1 && _ctx.statusArray.includes(option.id))
                    ? (_openBlock(), _createElementBlock("u", {
                        key: 0,
                        class: "option__remove",
                        onClick: _withModifiers(($event: any) => (_ctx.remove(option, i, $event)), ["stop"])
                      }, "remove", 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_4))
              }), 256))
            ]),
            _: 1
          }, 8, ["offset", "anchor"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default", {
        statusArray: _ctx.statusArray,
        loading: _ctx.loading
      }, undefined, true)
    ])
  ]))
}